import { Component, input } from '@angular/core';
import { AbsenceOptionUnit } from '@app/enums';

import { EnhancedAbsenceModel } from '../../../../../../reducers/orm/absence/absence.model';
import { CustomFieldsModel } from '../../../../../../reducers/orm/custom-fields/custom-fields.model';
import {
  TimesheetColumns,
  TimesheetCustomFieldsColumns,
} from '../../../../../../reducers/page-filters/page-filters.model';

@Component({
  standalone: false,
  selector: 'timesheet-row-absence',
  templateUrl: './timesheet-row-absence.component.html',
  host: {
    class: 'timesheet__absence-info',
  },
})
export class TimesheetRowAbsenceComponent {
  absenceOptionUnit = AbsenceOptionUnit;

  date = input.required<string>();
  absence = input.required<EnhancedAbsenceModel>();

  cols = input<TimesheetColumns>();

  customFields = input<CustomFieldsModel[]>([]);
  customFieldCols = input<TimesheetCustomFieldsColumns>();
}
